import promise from 'es6-promise' ; 
promise.polyfill();
import axios from 'axios'
import apiURL from './api'
import router from '../router'
import store from '../store/store'

// axios默认配置
axios.defaults.timeout = 120000;   // 超时时间
axios.defaults.baseURL = apiURL;  // 默认地址
// axios.defaults.baseURL = 'application/json;charset=utf-8';  // 默认地址

// // 路由请求拦截
// // http request 拦截器
axios.interceptors.request.use(
  config => {
    //config.data = JSON.stringify(config.data);  
    config.headers['Content-Type'] = 'application/json;charset=UTF-8';
    //判断是否存在ticket，如果存在的话，则每个http header都加上ticket
//     if (cookie.get("token")) {
//         //用户每次操作，都将cookie设置成2小时
//         cookie.set("token",cookie.get("token") ,1/12)    
//         cookie.set("name",cookie.get("name") ,1/12)
// 　　　　 config.headers.token = cookie.get("token");
// 　　　　 config.headers.name= cookie.get("name");
//     }
    
    return config;
  },
  error => {
    return Promise.reject(error.response);
  });

// // 路由响应拦截
// // http response 拦截器
axios.interceptors.response.use(
  response => {
      if(response.data.status_code == 402){
        // console.log(response)
        // console.log(1111)
        // localStorage.clear()
        localStorage.removeItem("user_id");
        // store.commit('deleteuserid', 1)
        // console.log(store.state.user_id)
        // router.push({path:'/login'})
        router.push({
          name: "login",
          params:{
            again:'expired'
          }
        })
        // setTimeout(function(){
        //     router.go(0);
        // },50)
        return 
    }else{
        return response;
    }
//     if (response.data.resultCode=="404") {
//         console.log("response.data.resultCode是404")
//         // 返回 错误代码-1 清除ticket信息并跳转到登录页面
// //      cookie.del("ticket")
// //      window.location.href='http://login.com'
//         return
//     }else{
        // return response;
//     }
  },
  error => {
    return Promise.reject(error.response)   // 返回接口返回的错误信息
  });
export default axios;


// WEBPACK FOOTER //
// ./src/util/http.js